window.customElements.define(
    "corporation-sold-to-combo",
    class extends HTMLElement {
        connectedCallback() {
            const corporationSelect = this.querySelector<HTMLSelectElement>("select[name='corporation_name']")!;
            const corporationFormItem = corporationSelect.closest(".form-item")!;

            const removeFilters = () => {
                this.querySelector("select[name='sold_to_customer_region']")?.closest(".form-item")?.remove();
                this.querySelector("select[name='sold_to_customer_number']")?.closest(".form-item")?.remove();
            };

            const fetchFilters = async (searchParameters) => {
                removeFilters();

                if (corporationSelect.value === "") {
                    return;
                }

                const response = await fetch(`${this.dataset.url}?${new URLSearchParams(searchParameters)}`);

                if (!response.ok) {
                    return;
                }

                corporationFormItem.insertAdjacentHTML("afterend", await response.text());
            };

            this.addEventListener(
                "change",
                (event) => {
                    const target = event.target as HTMLSelectElement;

                    if(target.value === "") {
                        return;
                    }

                    switch (target.name) {
                        case "corporation_name":
                            fetchFilters({
                                corporation_name: corporationSelect.value
                            });
                            break;

                        case "sold_to_customer_region":
                            fetchFilters({
                                corporation_name: corporationSelect.value,
                                sold_to_region: target.value,
                            });
                            break;

                        case "sold_to_customer_number":
                            window.location.href = target.value;
                            break;
                    }
                },
            );
        }
    },
);
